module.exports = __webpack_public_path__ + "img/1.6d55fdf6.png";